<div class="global-dialog-container">
    <div *ngIf = "dragCheck" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header-container">
        <div class="dialog-title-container">
            <!-- <ng-content select = "[dialogTitle]"></ng-content> -->
            <h2 dialogTitle>Speech to text conversion</h2>
        </div>
        <div class="dialog-close-icon-container">
            <div class="dialog-close-icon">
                <button mat-icon-button id = "minimize-btn" class="close-icon-bttn">
                    <mat-icon class="close-icon mb-10" mat-dialog-close>
                        minimize
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="dialog-header-container" id = "normal-header">
        <div class="dialog-title-container">
            <ng-content select = "[dialogTitle]"></ng-content>
        </div>
        <div class="dialog-close-icon-container">
            <div class="dialog-close-icon">
                <button mat-icon-button  disableRipple class="close-icon-bttn close-icon2">
                    <mat-icon class="close-icon" mat-dialog-close>
                        close
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
    <mat-divider class = "mat-divider"></mat-divider>
    <div mat-dialog-content class="mat-content-container">
        <div class="dialog-content-container">
            <ng-content select = "[contentContainer]"></ng-content>
        </div>
    </div>
    <div mat-dialog-actions class="mat-actions-container">
        <div class="dialog-action-container">            
            <ng-content select = "[actions]"></ng-content>
        </div>
    </div>
</div>
